// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"05409f7d","977":"b584b783"}[chunkId] + ".chunk.js";
};